'use client';
import Image from 'next/image';
// We can use this component to safely render images without the need to check if the src is empty
// sometimes server and client side rendering can cause issues with images, this component will handle that
const SafeImage = ({ src, alt, ...props }) => {
    if (!src)
        return null;
    return <Image {...props} alt={alt || ''} src={src}/>;
};
export default SafeImage;
//# sourceMappingURL=SafeImage.jsx.map